import * as React from 'react'

export const NotAuthorizedPageContent = () => (
  <div className='not-authorized grid'>
    <div className='col-12'>
      <div className='card'>Not Authorized</div>
    </div>
  </div>
)
